/**
 * GET /v1/schools/:schoolId/school-users/search
 *
 * Name search over a school's users, for pickers (add a member to a group).
 * Mirrors `apps/backend/src/api/schools/v1/use-cases/(users)/school-users/(core)/search/schema.ts`.
 */

import { z } from 'zod'
import { PaginationMetaSchema } from '../common'

export const SchoolUserSearchResultSchema = z.object({
  id: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  preferredFirstName: z.string(),
  preferredLastName: z.string(),
  photoUrlThumbnail: z.string(),
  /** Active role names: `student`, `parent`, `faculty`. */
  roles: z.array(z.string())
})

export type SchoolUserSearchResult = z.infer<typeof SchoolUserSearchResultSchema>

export const SearchSchoolUsersResponseSchema = z.object({
  data: z.array(SchoolUserSearchResultSchema),
  meta: PaginationMetaSchema,
  message: z.string()
})

export type SearchSchoolUsersResponse = z.infer<typeof SearchSchoolUsersResponseSchema>
